import { isTokenExpired } from '../helpers'

export const isRecoveryTokenExpired = token => {
  try {
    return isTokenExpired(token)
  } catch {
    return true
  }
}

export const getIdentifierAndOrderNumberFromUrl = url => {
  const searchParams = url?.split('?')?.[1]
  let email = null
  let identifier = null
  let orderNumber = null
  let joinGroup = null
  let recoveryToken = null

  if (searchParams) {
    const urlParams = new URLSearchParams(searchParams)
    orderNumber = urlParams.get('orderNumber')
    email = urlParams.get('orderEmail')
    identifier = urlParams.get('identifier')
    joinGroup = urlParams.get('joinGroup')
    recoveryToken = urlParams.get('recoveryToken')
  }

  return { orderNumber, identifier: identifier || email, joinGroup, recoveryToken }
}

export const getAllReturnPortals = merchantInfo => {
  const currentPortal = {
    name: merchantInfo?.name,
    slug: merchantInfo?.slug,
    selector_message: merchantInfo?.selector_message,
  }

  return [currentPortal, ...merchantInfo.siblingReturnPortals]
}
